export function setCookie(name: string, value: string | null = null, days: number = 60, path: string = '/') {
    if (!value) return removeCookie(name, path);
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=${path}`;
}

export function removeCookie(name: string, path: string = '/') {
    document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export function getCookie(name: string) {
    return document.cookie
      .split(";")
      .find((row) => row.trim().startsWith(`${name}=`))
      ?.split("=")[1] ?? "";
}

export function isCookieValid(name: string): boolean {
    const cookie = getCookie(name);
    return !!cookie;
}

export type SameSiteValue = 'Lax' | 'Strict' | 'None';

export interface CookieOptions {
    days?: number;
    path?: string;
    sameSite?: SameSiteValue;
    secure?: boolean;
    encodeValue?: boolean;
}

export function setCookieAdvanced(name: string, value: string | null = null, options: CookieOptions = {}) {
    if (!value) return removeCookie(name, options.path || '/');

    const days = options.days ?? 60;
    const path = options.path ?? '/';
    const sameSite: SameSiteValue = options.sameSite ?? 'Lax';
    const isHttps = typeof location !== 'undefined' && location.protocol === 'https:';
    const secure = options.secure ?? isHttps;
    const encodeValue = options.encodeValue ?? true;

    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }

    const encoded = encodeValue ? encodeURIComponent(value) : value;
    const secureAttr = secure ? '; Secure' : '';

    document.cookie = `${name}=${encoded}${expires}; path=${path}; SameSite=${sameSite}${secureAttr}`;
}